import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import BaseDecorator from '../../base-decorator';
import { AlertsService } from '../../services/alerts.service';
import { LoaderService } from '../../services/loader.service';
import { AppService } from '../../shared/services/app.service';
import { BaseService } from '../../shared/services/base.service';
import { DialogRef } from '../dialog/dialog-ref';
import { TagForm } from './tag-form.model';
import { Validators } from '@angular/forms';
import { DialogConfig } from '../dialog/dialog-config';

@Component({
    selector: 'tag-row',
    templateUrl: './tag-row.component.html',
    styleUrls: ['./tag-row.component.scss'],
    standalone: false
})
export class TagRowComponent extends BaseDecorator implements OnInit {
  @Input() data: any;
  @Input() action: any;
  currentConfig: any = {
    config: {
      "submitButton": true,
      "cancelButton": false,
      "filterForm": false,
      "clearOnSave": true,
      "delegateSave": true,
      "cancelRoute": ''
    }
  };
  self: this;
  comAction: any;

  constructor(public route: ActivatedRoute, public loader: LoaderService, public baseService: BaseService, public alerts: AlertsService, public dialogRef: DialogRef, public appService: AppService, private dialogConfig: DialogConfig) {
    super(route, 'TagRowComponent');
    this.self = this;
  }

  ngOnInit(): void {
    this.currentConfig['form'] = new TagForm().form;
    this.currentConfig['rowData'] = this.data || this.dialogConfig?.['data'] || {};
    if (this.action) {
      this.comAction = JSON.parse(JSON.stringify(this.action));
    }
    //this work in case of update
    if (this.currentConfig['rowData'].tag_data != undefined) {
      let cloneTags = JSON.parse(JSON.stringify(this.currentConfig['rowData'].tag_data));
      cloneTags.map(data => data['value_dropdown'] = data['key_value_code']);
      this.currentConfig.formVal = { attributes: cloneTags };
    }
  }
  valueChangeEnd(e: any, formObj) {
    if (e.question != undefined && e.question.key == "key_name") {
      let val = e.question.options.find(x => x.id === e.val.id);
      if (val && val.isDropdown != undefined && val.isDropdown === false) {
        formObj.form.controls.value_free.question_component.question.visible = true;
        // formObj.form.controls.value_free.question_component.question.required = false;
        formObj.form.controls.value_dropdown.question_component.question.visible = false;
        formObj.form.controls.value_dropdown.setValidators(null);
        formObj.form.controls.value_dropdown.updateValueAndValidity();
        formObj.form.controls.value_free.addValidators(Validators.required);
      }
      else {
        formObj.form.controls.value_free.question_component.question.visible = false;
        formObj.form.controls.value_free.question_component.question.required = true;
        formObj.form.controls.value_dropdown.question_component.question.visible = true;
        formObj.form.controls.value_free.setValidators(null);
        formObj.form.controls.value_free.updateValueAndValidity();
        formObj.form.controls.value_dropdown.addValidators(Validators.required);
        // formObj.form.controls.value_free.question_component.question.required = false;
      }
    }

  }
  valueChangeStart(e: any, formObj) {
    if (e.question != undefined && e.question.key == "value_free" && formObj != undefined && formObj.form != undefined && formObj.form.controls != undefined && formObj.form.controls.value_free != undefined && formObj.form.controls.value_free.value != undefined && formObj.form.controls.value_free.value) {
      formObj.form.controls.key_value_code.setValue(formObj.form.controls.value_free.value);
      formObj.form.controls.key_value_display.setValue(formObj.form.controls.value_free.value);
    }
    else if (e.question != undefined && e.question.key == "value_dropdown" && formObj != undefined && formObj.form != undefined && formObj.form.controls != undefined && formObj.form.controls.value_dropdown != undefined && formObj.form.controls.value_dropdown.value != undefined && formObj.form.controls.value_dropdown.value) {
      formObj.form.controls.key_value_code.setValue(formObj.form.controls.value_dropdown.value);
    }
  }

  saveFinished(e) {
    let action = "MODIFY";
    let result = this.mapResult(e.result, this.currentConfig['rowData']);
    let resource = this.comAction != undefined && this.comAction.config != undefined && this.comAction.config.tag_info != undefined && this.comAction.config.tag_info.post_resource != undefined ? this.comAction.config.tag_info.post_resource : this.baseService._resourceName;
    this.postData(result, action, this.appService.getApplication(), resource, (data) => {
      if (data) {
        this.dialogRef.close();
      }
    });
  }

  postData(result, action, application, resource, callback?, hideMsg?) {
    this.loader.showSpinner();
    this.baseService.action(result, action, application, resource).subscribe(data => {
      if (data.errCode == -1) {
        this.alerts.error(data.message);
        if (callback) {
          callback(false);
        }
      } else {
        if (!hideMsg) {
          this.alerts.success(data.message);
        }
        if (callback) {
          callback(data.resource);
        }
      }
      this.loader.hideSpinner();
    })
  }

  async getData(queryId, args, resource, application, filter, toStoredin, callback?) {
    // (queryId, args, resource = null, application?: any, filter?: any, responseType?: any, config?: any)
    await this.baseService.get(queryId, args, resource, application, filter).toPromise().then(data => {
      if (data && data.resource != undefined && data.resource.length != undefined && data.resource.length > 0) {
        this.currentConfig[toStoredin] = data.resource;
        console.log(toStoredin, this.currentConfig[toStoredin]);
        if (callback) {
          callback(this.currentConfig[toStoredin]);
        }
      }
      else if (callback) {
        callback(false);
      }
    })
  }

  mapResult(result, rowData) {
    let rowDataClone = JSON.parse(JSON.stringify(rowData));
    let obj = {};
    rowDataClone['tag_data'] = result.attributes;
    // for (let currentObj of result.attributes) {
    //   obj[currentObj.tagId] = currentObj.value;
    // // }
    // rowDataClone['tag_data'] = { ...rowDataClone['tag_data'], ...obj };
    return rowDataClone;
  }

}
